import type { Vehicle } from "@/domain/models/vehicle";
import type { VehicleRepository } from "@/domain/repositories/vehicle.repository";
import type { HttpClient } from "@/infrastructure/http/http-client";
import { mapVehicleDto, type VehicleDto } from "@/infrastructure/mappers/vehicle.mapper";

export class HttpVehicleRepository implements VehicleRepository {
  constructor(private readonly http: HttpClient) {}

  async list(): Promise<Vehicle[]> {
    const rows = await this.http.get<VehicleDto[]>("/vehicles");
    return rows.map(mapVehicleDto);
  }

  async getById(id: string): Promise<Vehicle | null> {
    const row = await this.http.get<VehicleDto | null>(`/vehicles/${id}`);
    return row ? mapVehicleDto(row) : null;
  }

  async create(input: Omit<Vehicle, "id">): Promise<Vehicle> {
    const row = await this.http.post<VehicleDto>("/vehicles", input);
    return mapVehicleDto(row);
  }

  async update(id: string, input: Partial<Vehicle>): Promise<Vehicle> {
    const row = await this.http.patch<VehicleDto>(`/vehicles/${id}`, input);
    return mapVehicleDto(row);
  }

  async remove(id: string): Promise<void> {
    await this.http.delete<null>(`/vehicles/${id}`);
  }
}
